import Grid from '@material-ui/core/Grid'
import React, { Component } from 'react'
import { getCardEnableData, getEMPI, getEnrolledMemberData, getMyneedsEOS, getMyneedsEOSnew } from '../../ApiCall'
import CommonLoader from '../../CommonLoader'
import ChatIcon from '../../WebScreen/ChatBox/ChatIcon'
import MobCopyright from '../MobCopyright'
import { Tab, Tabs } from '@material-ui/core'
import MyNeedsSimpleAccordion from '../MobileCommonComponents/myneedsAccordion'
import MobileHeader from '../MobileHeader'
import customStyle from '../../WebScreen/programInfo/CSS/stylesheet_UHS'
import { withStyles } from '@material-ui/styles'
import MobileFooter from './../MobileFooter'
import ContributionmyneedsAccordion from '../MobileCommonComponents/ContributionmyneedsAccordion'
import ContributionAccordian from '../MobileCommonComponents/ContributionAccordion'
import Modal1 from 'react-awesome-modal'
import ReimbursementDataTable from '../../WebScreen/ReimbursementDataTable'
import apiService from '../../../utils/apiservice'

const AntTabs = withStyles(customStyle.MyneedsTabs)(Tabs)

export default class MyNeedsMobile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      sampleData: [],
      response: [],
      formatedjsonData: null,
      page: 0,
      loader: true,
      loadMoreBtnshow: false,
      notfoundmsg1: '',
      notfoundmsg2: '',
      notfoundmsg3: '',
      tabEnable: localStorage.getItem('isAdmin') ? true : false,
      selectedTab: 'MyShareRequests',
      showReimbursementFormInTab: false,
      selectedRowData: null,
      familyMembers: []
    }
  }

  componentDidMount() {
    this.getCardEnable()
    this.getEMPID()
    this.callapi()
    // Listen for reimbursement form completion event from iframe using postMessage
    window.addEventListener('message', this.handleReimbursementComplete)
  }

  componentWillUnmount() {
    // Clean up event listener
    window.removeEventListener('message', this.handleReimbursementComplete)
  }

  handleReimbursementComplete = event => {
    // Check if the message is from the reimbursement iframe
    if (event.data?.type === 'memberReimbursementRequestComplete') {
      const eventData = event.data?.data || {}

      // Check if the event contains error information
      if (event.data?.error || event.data?.status === 'error') {
        console.error('Reimbursement request error:', eventData)
        // Handle error case - perform back button function
        this.goBack()
      } else {
        // Handle success case - perform back button function
        console.log('Reimbursement request completed successfully:', eventData)
        this.goBack()
      }
    }
  }

  getEMPID() {
    getEMPI().then(res => {
      console.log('=============getEMPI===========', res)
    })
  }

  callapi() {
    getMyneedsEOS(this.state.page).then(res => {
      console.log('==============MY needs data mobile===========', res.data)
      if (res.data.length > 0) {
        this.setState({ response: res.data, loader: false })
      } else {
        this.setState({
          notfoundmsg1:
            'No needs have been entered into the system. Submitted needs may take 2-3 days to be displayed here. For any clarifications call Customer Service.',
          loader: false
        })
      }

      if (res.data.length > 10) {
        this.setState({ loadMoreBtnshow: true })
      }
      this.setState({ response: res.data, page: this.state.page + 1, loader: false })
      this.createjson()
    })
  }

  callapiLoadmore() {
    this.setState({ loader: true })

    getMyneedsEOS(this.state.page).then(res => {
      console.log('==============TRansaction data mobile===========', res.data)
      console.log('my loade more res===', res)
      var resnew = res.data
      var data = this.state.response
      var newdata = data.concat(resnew)

      console.log('new data loade more is==', newdata)

      if (res.data.totalrecords === newdata.length) {
        this.setState({ loadMoreBtnshow: false })
      }
      this.setState({ response: newdata, loader: false, page: this.state.page + 1 })
      this.createjson()
    })
  }

  getCardEnable = () => {
    let client_id = localStorage.getItem('CLIENT_ID')

    getCardEnableData(client_id, 'MyNeeds').then(res => {
      console.log('getCardEnableData=====', res.data.response.enable)

      if (res.data.response.enable == 'false' || res.data.response.enable == false) {
        window.location.href = '/'
      }
    })
  }

  getEnrolledMember = async () => {
      try {
        const res = await getEnrolledMemberData();
  
        if (res && res.data) {
          this.setState({
            enrolledDataMember: res.data
          });
  
          return res.data;
        }
  
        return [];
      } catch (error) {
        console.log(error);
        return [];
      }
    };
    
  getFamilyMembers = async () => {
    let email = localStorage.getItem('userMail')

    if (!email) {
      console.log('Email not found in localStorage')
      return []
    }
    try {
      const enrolledDataMember =
        await this.getEnrolledMember();

      if (
        enrolledDataMember &&
        Array.isArray(enrolledDataMember)
      ) {
        return enrolledDataMember.map(
          member => {
            return {
              memberId: member.memberId,
              firstName: member.firstName || '',
              middleName:
                member.middleName || '',
              lastName: member.lastName || '',
              prefix: member.prefix || '',
              suffix: member.suffix || '',
              status: member?.status || '',
              benefitEnd:
                member?.benefits?.[0]
                  ?.benefitEnd || '',
              fullName: `${member.prefix || ''} ${member.firstName || ''
                } ${member.middleName || ''} ${member.lastName || ''
                } ${member.suffix || ''}`
                .trim()
                .replace(/\s+/g, ' ')
            };
          }
        );
      }

      return [];
    } catch (err) {
      console.error(
        'Error fetching family members:',
        err
      );
      return [];
    }
  }

  goBack = () => {
    if (this.state.showReimbursementFormInTab) {
      // destroy plugin UI
      const container = document.getElementById('reimbursement-plugin-container')

      if (container) {
        container.innerHTML = ''
      }

      // optional plugin cleanup
      if (window.closeCommonPluginScreen) {
        window.closeCommonPluginScreen()
      }

      this.setState({
        showReimbursementFormInTab: false,
        selectedTab: 'MyReimbursementRequests',
        selectedRowData: null
      })

      return
    }

    this.props.history.push('/')
  }

  getMemberData = () => {
    return {
      phone: localStorage.getItem('phone') || '',
      memberId: localStorage.getItem('EMPID') || '',
      email: localStorage.getItem('userMail') || '',
      initiatedUser: localStorage.getItem('userMail') || '',
      source: 'MemberPortal',
      userRole: 'USER',
      type: 'Reimbursement',
      client: 'UHF',
      memberName: localStorage.getItem('subscriberName') || '',
      requestId: this.state.selectedRowData?.id || ''
    }
  }

  openReimbursementForm = async (rowData = null) => {
    window.scrollTo(0, 0);

    const EMPID = localStorage.getItem('EMPID');

    this.setState(
      {
        selectedTab: 'MyReimbursementRequests',
        showReimbursementFormInTab: true,
        selectedRowData: rowData
      },
      async () => {
        // 1. Prepare your data first
        const familyMembers = await this.getFamilyMembers();
        const EMPID = localStorage.getItem('EMPID');
        const data = {
          ...this.getMemberData(),
          familyMembers,
        };

        // 2. Define a function to initialize the plugin
        const initPlugin = () => {
          const container = document.getElementById('reimbursement-plugin-container');
          
          if (!container) return false;

          if (window.loadCommonPluginScreen) {
            window.loadCommonPluginScreen(EMPID || '', {
              ...data,
              token: localStorage.getItem('token') || '',
              onComplete: (payload) => {
                console.log('Completed:', payload);
                this.goBack();
              },
            });
            return true; // Success
          }
          return false; // Not ready yet
        };

        // 3. Attempt to load with a small retry logic
        let attempts = 0;
        const maxAttempts = 20; // Try for 2 seconds (100ms * 20)

        const interval = setInterval(() => {
          const success = initPlugin();
          attempts++;

          if (success || attempts >= maxAttempts) {
            clearInterval(interval);
            if (!success) {
              console.error('Plugin failed to load after 2 seconds');
              // Optional: Show an error toast or fallback UI here
            }
          }
        }, 100); // Check every 100ms
      }
    );
  };

  combineDate = (x, y) => {
    if (x == y) {
      return x
    }

    const z = x + '-' + y
    return z
  }
  createjson() {
    var formatredjson = []

    this.state.response.map((item, i) => {
      var newobject = {}
      newobject.ExpenseNumberLabel = 'Expense Number'
      newobject.ExpenseNumberVal = item.bill_key

      newobject.DateOfServiceLabel = 'Date of Service'
      newobject.DateOfServiceVal = item.service_date

      newobject.statusClass = item.status
      newobject.status = item.status

      newobject.ProviderLabel = 'Provider'
      newobject.ProviderVal = item.paid_provider_name

      newobject.ChargedLabel = 'Charged'
      newobject.ChargedVal = item.charged_amount

      newobject.PaidLabel = 'Paid'
      newobject.PaidVal = item.paid_amount

      newobject.row7 = 'Member'
      newobject.rowval7 = item.first_name + ' ' + item.last_name

      newobject.row8 = 'Paid Date'
      newobject.rowval8 = item.date_received

      var innerobject = {
        DateofServiceLabel: 'Date(s) of Service',
        DateofServiceVal: this.combineDate(item.start_of_service_date, item.end_date_of_service),

        ProviderNameLabel: 'Provider',
        ProviderNameVal: item.paid_provider_name,

        BillChargeLabel: 'Amount Billed',
        BillChargeVal: '$' + item.charged_amount.toFixed(2),

        IneligibleforSharingLabel: 'Ineligible for Sharing',
        IneligibleforSharingVal: '$' + item.ineligible_amount.toFixed(2),

        DiscountToBilledChargesLabel: 'Adjustment',
        DiscountToBilledChargesVal: '$' + item.repricing_amount.toFixed(2),

        EligibleforSharingLabel: 'Allowed Amount',
        EligibleforSharingVal: '$' + item.eligible_for_sharing.toFixed(2),

        NonShareableAmountLabel: 'Non-Shareable Amount',
        NonShareableAmountVal: '$' + item.non_sharable_amount.toFixed(2),

        ConsultationFeeLabel: 'Consultation Fee',
        ConsultationFeeVal: '$' + item.consultation_fee.toFixed(2),

        ShareableAmountLabel: 'Shared Amount',
        ShareableAmountVal: '$' + item.shared_amount.toFixed(2),

        MemberResponsibilityLabel: 'Member Responsibility',
        MemberResponsibilityVal: '$' + item.member_responsibility.toFixed(2),

        PendingReasonLabel: 'Pending Reason',
        PendingReasonVal: item.pend_reason || 'N/A'
        // SharedByUHFLabel: 'Shared By UHF',
        // SharedByUHFVal: '$' + item.paid_amount
      }

      newobject.MoreDetail = innerobject

      formatredjson = formatredjson.concat({ ...newobject, ...item })
    })

    this.setState({ formatedjsonData: formatredjson })
  }
  Contributioncreatejson() {
    var formatredjson = []

    this.state.response.map((item, i) => {
      var newobject = {}
      // newobject.ExpenseNumberLabel = 'Reference #'
      // newobject.ExpenseNumberVal = item.bill_key

      newobject.DateOfServiceLabel = 'Date of Service'
      newobject.DateOfServiceVal = item.service_date

      newobject.statusClass = item.status
      newobject.status = item.status

      newobject.ProviderLabel = 'Provider'
      newobject.ProviderVal = item.paid_provider_name

      newobject.ChargedLabel = 'Charged Amount'
      newobject.ChargedVal = item.charged_amount

      newobject.PaidLabel = 'Paid Amount'
      newobject.PaidVal = item.paid_amount

      newobject.row7 = 'Member'
      newobject.rowval7 = item.first_name + ' ' + item.last_name

      newobject.row8 = 'Paid Date'
      newobject.rowval8 = item.date_received

      var innerobject = {
        DateofServiceLabel: 'Date(s) of Service',
        DateofServiceVal: this.combineDate(item.service_date),

        ProviderNameLabel: 'Provider',
        ProviderNameVal: item.paid_provider_name,

        BillChargeLabel: 'Amount Billed',
        BillChargeVal: '$' + item.charged_amount.toFixed(2),

        IneligibleforSharingLabel: 'Ineligible for Sharing',
        IneligibleforSharingVal: '$' + item.ineligible_amount.toFixed(2),

        DiscountToBilledChargesLabel: 'Adjustment',
        DiscountToBilledChargesVal: '$' + item.repricing_amount.toFixed(2),

        EligibleforSharingLabel: 'Eligible for Sharing',
        EligibleforSharingVal: '$' + item.eligible_for_sharing.toFixed(2),

        NonShareableAmountLabel: 'Non-Shareable Amount',
        NonShareableAmountVal: '$' + item.non_sharable_amount.toFixed(2),

        ConsultationFeeLabel: 'Consultation Fee',
        ConsultationFeeVal: '$' + item.consultation_fee.toFixed(2),

        ShareableAmountLabel: 'Shared Amount',
        ShareableAmountVal: '$' + item.shared_amount.toFixed(2),

        MemberResponsibilityLabel: 'Member Responsibility',
        MemberResponsibilityVal: '$' + item.member_responsibility.toFixed(2),

        PendingReasonLabel: 'Pending Reason',
        PendingReasonVal: item.pend_reason || 'N/A',

        paidDateLabel: '	Paid Date',
        paidDateVal: item.date_paid,
        RepricedAmountLabel: 'Repriced Amount',
        RepricedAmountVal: '$' + item.repricing_amount,
        MCPVLabel: `Visit Fees\n (MCP)`,
        MCVPValue: '$0.00',
        MCPLabel: 'Member Commitment Portion (MCP)',
        MCPvalue: '$' + item.mcp,
        ShareableAmountLabel: 'Shareable Amount',
        ShareableAmountValue: '$0.00'

        // SharedByUHFLabel: 'Paid Amount',
        // SharedByUHFVal: '$' + item.paid_amount
      }

      newobject.MoreDetail = innerobject

      formatredjson = formatredjson.concat(newobject)
    })

    this.setState({ formatedjsonData: formatredjson })
  }

  render() {
    const { formatedjsonData } = this.state
    return (
      <div className="">
        {this.state.loader ? <CommonLoader /> : null}
        { localStorage.getItem('SOURCE') !== 'NEO' ? 
        <MobileHeader name="Back" onBackClick={this.goBack} /> 
        : <MobileHeader name="My Needs" /> }
        { localStorage.getItem('SOURCE') !== 'NEO' && <>
        {!this.state.showReimbursementFormInTab && this.state.tabEnable && (
          <AntTabs
            value={this.state.selectedTab}
            onChange={(e, newValue) => this.setState({ selectedTab: newValue })}
            textColor="#33333"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
            variant="scrollable"
            scrollButtons="auto"
            id="tabs"
            style={{ width: '100%', height: 'auto', marginTop: 60 }}
          >
            <Tab
              label="MY NEEDS"
              value="MyShareRequests"
              style={{
                textTransform: 'capitalize',
                width: '13%',
                marginTop: window.mobileAndTabletCheck() ? '28px' : '10px',
                fontSize: '4vw',
                color: this.state.selectedTab == 'MyShareRequests' ? '#000' : '#7e7e7e'
              }}
            />
            <Tab
              label="MY CONTRIBUTIONS"
              value="MyCONTRIBUTIONS"
              style={{
                textTransform: 'capitalize',
                width: '20%',
                margin: window.mobileAndTabletCheck() ? '40px 0px 4px 0px' : '10px 0px 0px 0px',
                fontSize: '4vw',
                color: this.state.selectedTab == 'MyCONTRIBUTIONS' ? '#000' : '#7e7e7e'
              }}
            />
            <Tab
              label="MY REIMBURSEMENT REQUESTS"
              value="MyReimbursementRequests"
              style={{
                textTransform: 'capitalize',
                width: '25%',
                margin: window.mobileAndTabletCheck() ? '40px 0px 4px 0px' : '10px 0px 0px 0px',
                fontSize: '4vw',
                color: this.state.selectedTab == 'MyReimbursementRequests' ? '#000' : '#7e7e7e'
              }}
            />
          </AntTabs>
        )}
        {!this.state.showReimbursementFormInTab && !this.state.tabEnable && (
          <AntTabs
            value={this.state.selectedTab}
            onChange={(e, newValue) => this.setState({ selectedTab: newValue })}
            textColor="#33333"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
            variant="scrollable"
            scrollButtons="auto"
            id="tabs"
            style={{ width: '100%', height: 'auto', marginTop: 60 }}
          >
            <Tab
              label="MY NEEDS"
              value="MyShareRequests"
              style={{
                textTransform: 'capitalize',
                fontSize: '4vw',
                color: this.state.selectedTab == 'MyShareRequests' ? '#000' : '#7e7e7e'
              }}
            />
            <Tab
              label="MY REIMBURSEMENT REQUESTS"
              value="MyReimbursementRequests"
              style={{
                textTransform: 'capitalize',
                fontSize: '4vw',
                color: this.state.selectedTab == 'MyReimbursementRequests' ? '#000' : '#7e7e7e'
              }}
            />
          </AntTabs>
        )}
      </>}
        {this.state.showReimbursementFormInTab ? (
          <div
            key="plugin-container"
            id="reimbursement-plugin-container"
            style={{
              width: '100%',
              minHeight: '400px',
              marginTop:'35px'
            }}
          />
        ) : (
          <>
            {this.state.selectedTab === 'MyReimbursementRequests' ? (
              <div className="mobileCommonBody" style={{ marginBottom: '0px' }}>
                <ReimbursementDataTable onUpdateClick={rowData => this.openReimbursementForm(rowData)} />
              </div>
            ) : this.state.formatedjsonData ? (
              <div className={this.state.tabEnable ? 'mobileCommonBodyContribution' : 'mobileCommonBody'} style={{ marginBottom: '0px' }}>
                <div>
                  {this.state.tabEnable && this.state.selectedTab === 'MyShareRequests' ? (
                    <ContributionmyneedsAccordion data={formatedjsonData} />
                  ) : (
                    !this.state.tabEnable && <MyNeedsSimpleAccordion data={formatedjsonData} />
                  )}
                  {this.state.tabEnable && this.state.selectedTab === 'MyCONTRIBUTIONS' && <ContributionAccordian />}

                  {this.state.loadMoreBtnshow ? (
                    <div className="loadMoreWrapper">
                      {!this.state.tabEnable && (
                        <button className="loadMoreBtn" onClick={() => this.callapiLoadmore()}>
                          Load More
                        </button>
                      )}
                    </div>
                  ) : null}

                  {this.state.selectedTab !== 'MyCONTRIBUTIONS' && this.state.notfoundmsg1 == '' ? (
                    <Grid container style={{ padding: '10px', backgroundColor: 'white' }}>
                      <span style={{ fontStyle: 'Roboto', fontWeight: '500' }}>
                        **For complete status, please refer to the Explanation of Sharing (EOS) mailed to your address on file
                      </span>
                    </Grid>
                  ) : null}
                </div>

                {this.state.notfoundmsg1 == ''
                  ? null
                  : this.state.selectedTab !== 'MyCONTRIBUTIONS' && (
                      <div style={{ padding: '180px 0px', textAlign: 'center' }} className="mobile_data_not_found">
                        {this.state.notfoundmsg1}
                      </div>
                    )}
              </div>
            ) : null}
          </>
        )}

        {this.state.loader ? null : (
          <div>
            <div style={{ position: 'relative' }}>
              {!this.state.showReimbursementFormInTab && localStorage.getItem('SOURCE') !== 'NEO' && (
                <button
                  type="button"
                  className="myNeedsReimbursementBtn"
                  onClick={() => this.openReimbursementForm()}
                  style={{
                    width: '100%',
                    maxWidth: '280px',
                    padding: '12px 24px',
                    border: '2px solid #2e3192',
                    borderRadius: '50px',
                    backgroundColor: 'transparent',
                    color: '#2e3192',
                    fontFamily: 'Roboto',
                    fontSize: '14px',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    cursor: 'pointer',
                    marginBottom: '12px',
                    display: 'block',
                    margin: '0 auto 12px'
                  }}
                >
                  REIMBURSEMENT REQUEST
                </button>
              )}
              <ChatIcon showAIChatIcon={true} />
              <ChatIcon setAI={() => this.setState({ isAI: true })} />
              <MobCopyright />
            </div>

            <div class="fixed-bottom">
              <MobileFooter name="My Needs" />
            </div>
          </div>
        )}

        <Modal1 visible={this.state.isAI} width="90%" effect="fadeInUp">
          <div style={{ width: '90vw' }}>
            <div class="mqalert_modal_text">This service is currently offline. Please try again later.</div>
            <br />
            <div class="mqalert_button_div">
              <button className="mqalert_button" onClick={() => this.setState({ isAI: false })}>
                OK
              </button>
            </div>
          </div>
        </Modal1>
      </div>
    )
  }
}
